import React, {Component} from 'react';
import {connect} from "react-redux";
import { withTranslation } from 'react-i18next';
import Button from "../../../../../../components/button";
import {getSharingDetailsPopup} from "../../../../../../../actions/sharingDetailsActions";
import Icon from "../../../../../../components/icon";
import {isLabelsLoading} from "../../../../../../../actions/contactsGroupItemActions";

class LabelLoadingErrorPopup extends Component {

    constructor(props){
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(){
        this.props.getSharingDetailsPopup([]);
        this.props.setIsLabelsLoading(false);
    }

    render() {
        return (
            <div className="p-4">
                <h2 className="text-danger"><Icon name="times-circle" className="mr-1"/> {this.props.t("labelLoadingErrorText")}</h2>
                {
                    this.props.sharingDetailsPopup[2] ? <p>{this.props.sharingDetailsPopup[2]}</p> : <p>{this.props.t("textUnkownError")}</p>
                }
                <div className="text-right">
                    <Button className="btn-primary" onClick={this.handleClick}>{this.props.t("okText")}</Button>
                </div>

            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    getSharingDetailsPopup: (array) => {
        dispatch(getSharingDetailsPopup(array))
    },
    setIsLabelsLoading: (boolean) => {
        dispatch(isLabelsLoading(boolean))
    },
});

const mapStateToProps = (state) => {
    return {
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LabelLoadingErrorPopup));